/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagComputedFunctionInfos } from '../../models/tag-computed-function-infos';

export interface GetComputedTagsFunction$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  tagUid: string;
}

export function getComputedTagsFunction(http: HttpClient, rootUrl: string, params: GetComputedTagsFunction$Params, context?: HttpContext): Observable<StrictHttpResponse<TagComputedFunctionInfos>> {
  const rb = new RequestBuilder(rootUrl, getComputedTagsFunction.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('tagUid', params.tagUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagComputedFunctionInfos>;
    })
  );
}

getComputedTagsFunction.PATH = '/custom/stations/{uid}/tags-computed-function/{tagUid}';
